import { ReactComponent as Icon } from "./svg/icon_metrics_graph.svg";
import "./IconMetricsGraph.scss";

export const IconMetricsGraph = () => (
  <span className="icon-metrics-graph">
    <Icon />
  </span>
);
